import * as React from 'react';

interface Props {
	reverse?: boolean;
}

const FieldsOrder = React.memo((props: React.PropsWithChildren<Props>) => {
	let childsArray = React.Children.toArray(props.children);

	if (props.reverse) {
		childsArray = childsArray.reverse();
	}

	return <>{childsArray}</>;
});

export default FieldsOrder;
